(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about_slides"] && !Shopify.designMode) return;
  try {
    
$(function () {
  $('.about_slide_carousel').flickity({
    cellSelector: '.about_slide_item',
    contain: true,
		prevNextButtons: false,
		pageDots: false,
		autoPlay: true,
    wrapAround: true
  });
	
	$('.about_slide_navigation').flickity({
    cellSelector: '.slide_nav_link',
    contain: true,
		prevNextButtons: false,
		pageDots: false,
		autoPlay: true,
    wrapAround: true
  });

  $('.slide_nav_link').click(function (e) { 
    e.preventDefault();
    $('.about_slide_carousel').flickity( 'select', $(this).attr('data-slide-id'));
  });
  $('.about_slide_carousel').on( 'change.flickity', function( event, index ) {
    $('.slide_nav_link').removeClass('active');
    $('#slide_nav_' + index).addClass('active');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
  var elem = document.querySelector('.carousel-hero');
  var dot = true;
  if (elem.classList.contains('dot-disable')) {
    dot = false;
  }
  var flkty = new Flickity(elem, {
    // options
    cellAlign: 'left',
    contain: true,
    autoPlay: true,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: dot,
    sync: '.carousel-hero-mobile',
  });
  flkty.on('change', function (index) {
    //console.log( flkty.selectedIndex, flkty.selectedElement );
    //console.log('aa2');
    var selecedEl = flkty.selectedElement;
    if (selecedEl.classList.contains('video_slide')) {
      const videoEl = selecedEl.querySelector('.carousel_video_player');
      videoEl.setAttribute('src', videoEl.getAttribute('data-src'));
    }
  });

  var elem2 = document.querySelector('.carousel-hero-mobile');
  var dot2 = true;
  if (elem2.classList.contains('dot-disable')) {
    dot2 = false;
  }
  var flkty2 = new Flickity(elem2, {
    // options
    cellAlign: 'left',
    contain: true,
    autoPlay: false,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login"]) return;
  try {
    

if (window.location.hash == '#recover') { 

	document.querySelector(".login_form_wrapper").style.display = "none";
		document.querySelector(".forgot_form_wrapper").style.display = "block";

 }

	document.querySelector(".forgot_password").addEventListener("click", (e) => {
		document.querySelector(".login_form_wrapper").style.display = "none";
		document.querySelector(".forgot_form_wrapper").style.display = "block";
	 });
	 document.querySelector(".return_to_login").addEventListener("click", (e) => {
		document.querySelector(".forgot_form_wrapper").style.display = "none";
		document.querySelector(".login_form_wrapper").style.display = "block";
	 });

   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
const handleIntersection = (entries, observer) => {
	if (!entries[0].isIntersecting) return;

	observer.unobserve(productRecommendationsSection);

	const url = productRecommendationsSection.dataset.url;

	fetch(url)
		.then(response => response.text())
		.then(text => {
			const html = document.createElement('div');
			html.innerHTML = text;
			const recommendations = html.querySelector('.product-recommendations');

			if (recommendations && recommendations.innerHTML.trim().length) {
				productRecommendationsSection.innerHTML = recommendations.innerHTML;
			}

			var elem = document.querySelector('.featured_collection_carousel_reco');
			var flkty = new Flickity( elem, {
				cellAlign: "left",
				contain: true,
				pageDots: false,
				prevNextButtons: false,
				resize: true,
				imagesLoaded: true,
				wrapAround: true
			});


			document.querySelector(".featured_recommendations .btn-carousel_next").addEventListener("click", (e) => {
			//	var targetCarousel = $(this).attr('rel');
			console.log(flkty);
			flkty.next()
			 });
		
			 document.querySelector(".featured_recommendations .btn-carousel_prev").addEventListener("click", (e) => {
				//var targetCarousel = $(this).attr('rel');
				console.log(flkty);
				flkty.previous()
			 });

			 


		})
		.catch(e => {
			console.error(e);
		});
};

const productRecommendationsSection = document.querySelector('.product-recommendations');
const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
